import { render, staticRenderFns } from "./GetQuestion.vue?vue&type=template&id=ff954714"
import script from "./GetQuestion.vue?vue&type=script&lang=js"
export * from "./GetQuestion.vue?vue&type=script&lang=js"
import style0 from "./GetQuestion.vue?vue&type=style&index=0&id=ff954714&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports